import React, { Component } from 'react';
import Navigation from "../Navigation/Navigation";
import Hero from "../General/Hero";
import Footer from "../General/Footer";
import TileList from "../Results/tileList";
import Captain from "../General/Captain";
import Pitch from "../General/Pitch";
import Rides from "../General/Rides";
import AdvancedSearch from "../Search/advancedSearch";

export default class Home extends Component {
    render() {
        return (
            <div className="home__main">
                <Navigation auth={this.props.auth} />
                <Hero />
                <AdvancedSearch />
                <TileList />
                <Pitch />
                <Rides />
                <Captain />
                <Footer />
            </div>
        )
    }
}
